
export default function RecentActivity() {
  const activities = [
    {
      id: 1,
      type: 'task',
      title: '完成了季度绩效评估',
      time: '2小时前',
      icon: 'ri-task-line',
      color: 'bg-green-500'
    },
    {
      id: 2,
      type: 'meeting',
      title: '参加了产品规划会议',
      time: '4小时前',
      icon: 'ri-video-line',
      color: 'bg-blue-500'
    },
    {
      id: 3,
      type: 'training',
      title: '完成了领导力培训课程',
      time: '1天前',
      icon: 'ri-graduation-cap-line',
      color: 'bg-purple-500'
    },
    {
      id: 4,
      type: 'report',
      title: '提交了周报',
      time: '2天前',
      icon: 'ri-file-text-line',
      color: 'bg-orange-500'
    },
    {
      id: 5,
      type: 'approval',
      title: '审批了采购申请',
      time: '3天前',
      icon: 'ri-checkbox-circle-line',
      color: 'bg-teal-500'
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">最近活动</h3>
        <button className="text-indigo-600 hover:text-indigo-700 text-sm font-medium cursor-pointer whitespace-nowrap">
          查看全部
        </button>
      </div>
      
      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-start space-x-3">
            <div className={`w-8 h-8 ${activity.color} rounded-full flex items-center justify-center flex-shrink-0`}>
              <i className={`${activity.icon} text-white text-sm`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 leading-5">
                {activity.title}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {activity.time}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-gray-200">
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center">
              <i className="ri-lightbulb-line text-indigo-600 text-sm"></i>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900">智能建议</h4>
              <p className="text-xs text-gray-600 mt-1">
                根据您的工作模式，建议优先处理绩效相关任务
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
